import { render, staticRenderFns } from "./ChatBotConfig.vue?vue&type=template&id=84397866&scoped=true&"
import script from "./ChatBotConfig.vue?vue&type=script&lang=js&"
export * from "./ChatBotConfig.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotConfig.vue?vue&type=style&index=0&id=84397866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84397866",
  null
  
)

export default component.exports